import React, { useEffect, useState } from "react";
import css from "./section.module.css";
import { useUserHook } from "../../../../context/UserContext";
import resources from "../../../../resources";
import Star from "./Star";
import { NavLink } from "react-router-dom";

const Section4 = () => {

  const { getUsers, getSingleUser, users, singleUser } = useUserHook();

  useEffect(() => {
    getUsers();
    getSingleUser(1); //by passing id:1 we are getting first element(an array of object)
  }, []);

  //At initial singleUser will be undefined
  if (singleUser[0] === undefined) {
     return(
      <h4>...Loading</h4>
     )
  } else {
    const { name, title, image, ratting, job_title, job_desc } = singleUser[0];

    return (
      <div className={css.section4}>
        <div className={css.div1}>
          <h3>Testomonial</h3>
          <h2>What They Say About Us</h2>
          <p>
            Uniquely promote adaptive quality vectors rather than stand-alone
            e-markets. pontificate alternative architectures whereas iterate.
          </p>
        </div>

        <div className={css.div2}>

          <div className={css.div2_text}>
            <img
              className={css.comma}
              src={resources.icons.comma}
              alt="section 4"
            />
            <h3>{job_title}</h3>
            <Star stars={ratting} />
            <br />
            <p>{job_desc}</p>
            <h5>{name}</h5>
            <h6>{title}</h6>
          </div>

          <div className={css.div2_img}>
            <figure>
              <img className={css.user_img} src={image} alt="User" />
              <img className={css.dot_img} src={resources.icons.dots} alt = "User bg"/>
            </figure>
          </div>
      
        </div>

        <div className={css.div3}>
          {users.map((user) => {
            const { image, name, title, id } = user;
            return (
              <NavLink
                key={id}
                className={css.user}
                onClick={() => {
                  getSingleUser(id)
                }}
              >
                <img src={image} />
                <div>
                  <h5>{name}</h5>
                  <h6>{title}</h6>
                </div>
              </NavLink>
            );
          })}
        </div>
      </div>
    );
  }
};

export default Section4;
